import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Hero from "./Hero";
import Navbar from "../../components/Navbar";
import Properties from "./Properties";
import WhyUs from "./WhyUs";
import Experiences from "./Experiences";
import Footer from "../../components/Footer";
import Reviews from "./Reviews";

const Landing = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-out",
      once: true,
      offset: 100,
    });
  }, []);

  return (
    <>
      <Navbar />
      <Hero />
      <Properties />
      <WhyUs />
      <Experiences />
      <Reviews />
      <Footer />
    </>
  );
};

export default Landing;
